/**
 * Layout constants shared across shell/layout primitives.
 *
 * Keep this file focused: only values that are used in multiple places
 * or represent app-wide layout decisions should live here.
 */

export const APP_SHELL_DEFAULT_LEFT_SIZE = 55;
export const APP_SHELL_MIN_LEFT_SIZE = 25;
export const APP_SHELL_MAX_LEFT_SIZE = 75;
export const APP_SHELL_MIN_RIGHT_SIZE = 25;

// Collapsed mode keeps a thin right strip visible for the expand affordance.
export const APP_SHELL_COLLAPSED_LEFT_SIZE = 98;
export const APP_SHELL_COLLAPSED_MIN_RIGHT_SIZE = 2;

// Shared panel header height (tabs row) for consistent alignment across panels.
// Tailwind class chosen to match current visual density while ensuring equal heights.
export const PANEL_HEADER_HEIGHT_CLASS = 'h-10';

// Floating overlay defaults (shared across callers).
export const FLOATING_OVERLAY_DEFAULT_INSET_PX = 16;
export const OVERLAY_PANEL_COLLAPSED_HEIGHT_PX = 120;

export const RX_WIZARD_OVERLAY_DEFAULT_SIZE = { width: 520, height: 840 } as const;
export const LAB_ORDER_WIZARD_OVERLAY_DEFAULT_SIZE = { width: 520, height: 840 } as const;
export const FOLLOW_UPS_OVERLAY_DEFAULT_SIZE = { width: 480, height: 640 } as const;
export const AI_DEBUG_OVERLAY_DEFAULT_SIZE = { width: 680, height: 720 } as const;
